/**
 * Forcing loading of all plugins. This is done to make dependencies simpler
 */
define('pluginLoader',[
        'knockout', 'knockout-mapping', 'lodash', 'jquery', 'atn/highchartsConfig',
        //  loading all the list of plugins GAMS-UI need
        'bootstrap', 'jqueryUi', 'common/allSettled', 'highstock', 'numeral', 'highstock.data',
        'highstock.drilldown', 'highstock.exporting', 'highstock.funnel', 'canvg', 'perfect-scrollbar',
        'customPlugins/atnCheckboxWidgets', 'customPlugins/atnKoHighchart', 'customPlugins/atnFastObservableArray',
        'customPlugins/atnFastResetableArray', 'customPlugins/injectAfterkeydownBinding',
        'customPlugins/atnHeightAdjuster',   'customPlugins/atnElement', 'customPlugins/atnDomEvent',
        'customPlugins/atnBooleanToggle',  'customPlugins/atnAutoHideNotification', 'customPlugins/atnExpand',
        'customPlugins/atnAutoRefocus', 'customPlugins/atnKoScrollbar', 'customPlugins/atnAccordion',
        'customPlugins/atnAccordionWidget', 'customPlugins/atnOverlayContainer', 'customPlugins/atnRouterViewFix',
        'customPlugins/atnAccordionScrollbar', 'customPlugins/atnKendoNumericTextBox',
        'customPlugins/atnKendoDateTimePicker', 'customPlugins/atnKendoDatePicker', 'customPlugins/atnKendoComboBox',
        'customPlugins/validationSettings', 'customPlugins/atnUIValidation',  'customPlugins/koTrackableObservable',
        'customPlugins/atnAreObservablesValid','kendo-knockout', 'knockout.validation'

    ],
    function(ko, mapping, _, $, highchartsConfig) {
        'use strict';
                //Set Highcharts global options.
        window.Highcharts.setOptions(highchartsConfig.chartConfig);
        // adding mappins pluggin to knockout
        //  suppoted kendo components
        var supportedKendoComponents = ['atnKendoComboBox', 'atnKendoNumericTextBox', 'kendoComboBox',
            'kendoDateTimePicker', 'kendoDatePicker'];

        _.assign(ko.validation.configure, {
            registerExtenders: true,
            messagesOnModified: true,
            insertMessages: true,
            parseInputAttributes: true,
            messageTemplate: null
        });

        ko.fiterKendoComponent = function(element, allBindings) {
            var pattern = '^(' + supportedKendoComponents.join('|') + ')$',
                bindings = allBindings(),
                //  list of matched kendo component binding names
                matchingKendoBindings = _.filter(_.keys(bindings), function(name) {
                    return name.match(pattern);
                }),
                returnValue;
            if (matchingKendoBindings.length) {
                var observable = bindings[matchingKendoBindings[0]].value,
                    widgetNode = element;

                while (!(widgetNode.className || '').match('k-widget')) {
                    widgetNode = widgetNode.parentElement;
                }
                widgetNode = widgetNode.parentElement;
                $(widgetNode).attr('atn-role', 'kendo-validation-parent');
                returnValue = {
                    observable: observable,
                    element: widgetNode
                };
            }
            return returnValue;
        };
        // enable validation
        ko.validation.init();
        // adding mappins pluggin to knockout
        ko.mapping = mapping;
    });
